import { html, css, unsafeCSS, nothing } from 'lit';
import SotbitButton from '../button';
import styles from './button-info.scss?inline';

export default class SotbitButtonInfo extends SotbitButton {
    static styles = [
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = {
        ...SotbitButton.properties,
        size: { type: String },
    };

    constructor() {
        super();

        this.size = 'm';
    }

    _getIconSize() {
        return this.size.toLowerCase() === 's' ? 'xxs' : 'xs';
    }

    render() {
        const aria = this.ariaLabel ? this.ariaLabel : (this.dataTooltip ?? '');

        return html`
            <div class="wrapper" part="wrapper">
                <button
                    class="button"
                    part="button"
                    ?disabled="${this.disabled}"
                    type="${this.type || nothing}"
                    form="${this.form || nothing}"
                    name="${this.name || nothing}"
                    value="${this.value || nothing}"
                    aria-label="${this.disabled ? nothing : aria}"
                >
                    <slot name="icon">
                        <sotbit-icon icon="info_i" size="${this._getIconSize()}" no-padding></sotbit-icon>
                    </slot>
                </button>
                <slot></slot>
            </div>
        `;
    }
}
